import { getDecimalPlaces } from "./decimals.js";
// src/common/utils/amount-format.ts
const INTL_CURRENCIES = new Set(Intl.supportedValuesOf("currency"));
const exactDigits = (amount) => ({
	minimumFractionDigits: getDecimalPlaces(amount),
	maximumFractionDigits: getDecimalPlaces(amount)
});
const formatNumber = (amount, locale, options) => new Intl.NumberFormat(locale, options).format(amount);
const formatInCurrency = (amount, currency, digits, locale) => INTL_CURRENCIES.has(currency) ? formatNumber(amount, locale, {
	style: "currency",
	currency,
	currencyDisplay: "symbol",
	...digits
}) : `${formatNumber(amount, locale, digits)} ${currency}`;
/**
* The UI language, with the region of the first browser locale in that language: `de-CH` for a
* German UI in a Swiss browser.
*/
const resolveFormattingLocale = (uiLocale, browserLocales) => {
	const { language } = new Intl.Locale(uiLocale);
	return browserLocales.find((locale) => new Intl.Locale(locale).language === language) ?? uiLocale;
};
const formatDecimalAmount = (amount, locale) => formatNumber(amount, locale, exactDigits(amount));
const formatCryptoAmount = (amount, symbol, locale) => `${formatDecimalAmount(amount, locale)} ${symbol.toUpperCase()}`;
const formatFiatAmount = (amount, currency, locale) => formatInCurrency(amount, currency, exactDigits(amount), locale);
/**
* Rounded half-up to the currency's decimals, or more to keep three significant digits:
* `66,666.67`, `0.004` or `0.00412`.
*/
const formatRate = (rate, currency, currencyDecimals, locale) => {
	const magnitude = Math.floor(Math.log10(Number(rate)));
	const significantDecimals = Number.isFinite(magnitude) ? 2 - magnitude : 0;
	return formatInCurrency(rate, currency, {
		minimumFractionDigits: currencyDecimals,
		maximumFractionDigits: Math.max(currencyDecimals, significantDecimals)
	}, locale);
};
export { formatCryptoAmount, formatDecimalAmount, formatFiatAmount, formatRate, resolveFormattingLocale };

//# sourceMappingURL=amount-format.js.map